module.exports = __webpack_public_path__ + "img/progressing.ecb27c70.png";